import { useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function VideoCarousel({ videos = [] }) {
  const [i, setI] = useState(0);
  const ref = useRef(null);
  const go = (d) => setI((c) => (c + d + videos.length) % videos.length);
  if (videos.length === 0) return null;

  return (
    <div className="relative w-full max-w-[320px] mx-auto" data-testid="karaoke-carousel">
      <div className="rounded-[1.75rem] overflow-hidden border border-white/10 bg-black shadow-lift aspect-[9/16]">
        <video
          key={videos[i]}
          ref={ref}
          src={videos[i]}
          autoPlay
          muted
          playsInline
          onEnded={() => go(1)}
          className="w-full h-full object-contain bg-black"
          data-testid={`karaoke-video-${i}`}
        />
      </div>

      {videos.length > 1 && (
        <>
          <button onClick={() => go(-1)} aria-label="Previous clip" data-testid="karaoke-prev"
            className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-espressoDeep/70 text-goldLight grid place-items-center backdrop-blur border border-white/10 hover:bg-espressoDeep active:scale-90 transition">
            <ChevronLeft size={20} />
          </button>
          <button onClick={() => go(1)} aria-label="Next clip" data-testid="karaoke-next"
            className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-espressoDeep/70 text-goldLight grid place-items-center backdrop-blur border border-white/10 hover:bg-espressoDeep active:scale-90 transition">
            <ChevronRight size={20} />
          </button>
          <div className="flex justify-center gap-2 mt-4">
            {videos.map((_, idx) => (
              <button key={idx} onClick={() => setI(idx)} aria-label={`Clip ${idx + 1}`} data-testid={`karaoke-dot-${idx}`}
                className={`h-1.5 rounded-full transition-all ${idx === i ? "w-8 gold-gradient" : "w-1.5 bg-white/30"}`} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
